var VirtualTyreConsultantJS = (function ($) {

    var addClickHandlerMotoSelector = function (submitElement) {

        $(document).on('submit', submitElement, function (event) {
            event.preventDefault();
            var manufacturer = $('#motoselector-default-manufacturer').val();
            var capacity = $('#motoselector-default-capacity').val();
            var model = $('#motoselector-default-model').val();
            var type = $('#motoselector-default-type').val();
            var formData = {manufacturer: manufacturer, capacity: capacity, model: model, type: type};
            $.ajax({
                url: '/virtual-tyre-consultant/moto-wheel-selection',
                data: formData,
                type: 'GET',
                success: function (data) {
                    $('#motoAssistantStartPage').replaceWith(data);
                    if ($('#wheelTypeOptions input:checked').length) {
                        $('#wheelTypeButton').prop('disabled', false);
                    }
                }
            })
        });
    };

    var addClickHandlerWheelTypeSelector = function (submitElement) {
        $(document).on('click', submitElement, function (event) {
            event.preventDefault();
            var wheelType = $('#wheelTypeOptions input:checked').val();
            var redirectToSearch = $('#skipDriveTypeSelection').val();
            var formData = {wheelType: wheelType,
                            redirectToSearch: redirectToSearch};
            var url;
            if (wheelType === 'completeTyre') {
                if(redirectToSearch === 'true') {
                    window.location.href = '/virtual-tyre-consultant/moto-drivingStyle-selection-search';
                    return;
                }
                url = '/virtual-tyre-consultant/moto-drivingStyle-selection'
            } else {
                url = '/virtual-tyre-consultant/moto-mountedTyres-selection'
            }
            $.ajax({
                url: url,
                data: formData,
                type: 'GET',
                success: function (data) {
                   $('#motoAssistantWheelType').replaceWith(data);
                }
            })
        })
    };

    var addClickHandlerBackButton = function (backButton) {
        $(document).on('click', backButton, function (event) {
            event.preventDefault();
            var destinationPage = $(backButton).data('backpage');
            var currentPage = $(backButton).data('currentpage');
            var data = {destinationPage: destinationPage};
            var url = '/virtual-tyre-consultant/moto-back-page';
            $.ajax({
                url: url,
                data: data,
                type: 'GET',
                success: function (data) {
                    $('#'+currentPage).replaceWith(data);
                    if ($('#motoselector-default-manufacturer').length) {
                        MotoSearchJs.addHandlers();
                        MotoSearchJs.initDropdowns();
                    }
                    if ($('#wheelTypeOptions input:checked').length) {
                        $('#wheelTypeButton').prop('disabled', false);
                    }
                }
            })
        })
    };

    var addChangeHandlerBrandFacet = function (selectOption) {
        $(document).on('change', selectOption, function (event) {
            event.preventDefault();
            var selectedBrand = $(selectOption).val();
            var url = '/virtual-tyre-consultant/moto-facet-reload-brand';
            var data = {selectedBrand: selectedBrand};
            removePreviousSelectedOptions('#vtc_facet_profilepattern');

            if (checkSelectedIndex($(selectOption))) {
                $.ajax({
                    url: url,
                    data: data,
                    type: 'GET',
                    success: function (data) {
                        $.each(data, function (i, profile) {
                            $('#vtc_facet_profilepattern').append('<option value="' + profile.code + '">' + profile.code + '</option>')
                        })
                    }
                })
            }
        })
    };

    var addChangeHandlerProfileFacet = function (selectOption) {
        $(document).on('change', selectOption, function (event) {
            $('#assistantSearchButton').prop('disabled', !checkSelectedIndex($('#vtc_facet_profilepattern')));
        });
    };

    function checkSelectedIndex(select) {
        return select && select[0] && select[0].selectedIndex > 0;
    }

    var addRadioTypeSelector = function (selectOption) {
        $(document).on('click', selectOption, function (event) {
            $('#wheelTypeButton').prop('disabled', false);
        });
    };

    var removePreviousSelectedOptions = function (select) {
        $(select).find('option:gt(1)').remove();
        $(select).prop('selectedIndex', 0);

        $('#assistantSearchButton').prop('disabled', true);
    };

    var addDrivingStyleHandlerSearch = function (selectOption) {
        $(document).on('click', selectOption, function (event) {
            event.preventDefault();
            window.location.href = '/virtual-tyre-consultant/moto-drivingStyle-selection-search?drivingStyle=' + $('#vtc_facet_drivingstyle').val();
        })
    };

    return {
        addClickHandlerMotoSelector: addClickHandlerMotoSelector,
        addClickHandlerWheelTypeSelector: addClickHandlerWheelTypeSelector,
        addClickHandlerBackButton: addClickHandlerBackButton,
        addChangeHandlerBrandFacet: addChangeHandlerBrandFacet,
        addChangeHandlerProfileFacet: addChangeHandlerProfileFacet,
        addDrivingStyleHandlerSearch: addDrivingStyleHandlerSearch,
        addRadioTypeSelector: addRadioTypeSelector
    }
})(jQuery);

$(document).ready(function () {
	var $virtualAssistantShowBtn = $('.virtual-assistant__show-btn');
	if ($virtualAssistantShowBtn.length) {
		$virtualAssistantShowBtn.on('click', function() {
			$(this).toggleClass('active');
			$('.virtual-assistant').toggleClass('active');
		});
	}
    
    if (!$('.virtual-assistant-page').length) {
        return;
    }
    if ($('#wheelTypeOptions input:checked').length) {
        $('#wheelTypeButton').prop('disabled', false);
    }

    VirtualTyreConsultantJS.addClickHandlerMotoSelector('.vtc-section #motoSearchByBrandForm');
    VirtualTyreConsultantJS.addClickHandlerWheelTypeSelector('#wheelTypeButton');
    VirtualTyreConsultantJS.addClickHandlerBackButton('#assistantBackButton');
    VirtualTyreConsultantJS.addChangeHandlerBrandFacet('#vtc_facet_brand');
    VirtualTyreConsultantJS.addChangeHandlerProfileFacet('#vtc_facet_profilepattern');
    VirtualTyreConsultantJS.addDrivingStyleHandlerSearch('#nextPageButton');
    VirtualTyreConsultantJS.addRadioTypeSelector('#wheelTypeOptions input');
});
